module.exports = __webpack_public_path__ + "static/media/img_hero_whyCRE.e990a2e2.jpg";